import { useQuery } from "@tanstack/react-query";
import {  getPageHeaderByKey } from "../api/pageApi";
import toast from "react-hot-toast";
import { useEffect } from "react";

export const usePageHeaderByKey = (key) => {
  const { data: pageHeader, isLoading, error } = useQuery({
    queryKey: ["pageHeaderByKey", key],
    queryFn: () => getPageHeaderByKey(key),
  });

  useEffect(() => {
    if (error) {
      toast.error(error.response?.data?.message || "Failed to fetch page header");
    }
  }, [error]);

  return {
    pageHeader,
    isLoading,
  };
}